import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { COMMONS_FRONTEND_URL } from "../constants/";

/**
 * Access Denied Page
 *
 * Shown when a user visits the enterprise (pro.commons) domain
 * but does not belong to an authorized enterprise cohort.
 */
const AccessDenied: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#F5F5F5",
        px: 3,
      }}
    >
      <img
        src="/materiom_logo.png"
        alt="Materiom Logo"
        style={{ height: 48, marginBottom: 48 }}
      />

      <Container maxWidth="sm" sx={{ textAlign: "center" }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mb: 2 }}>
          Access Denied
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 4, maxWidth: 420, mx: "auto" }}
        >
          Your account does not have access to this portal. Please contact your
          organisation administrator or visit the public Materiom Commons.
        </Typography>

        <Button
          variant="contained"
          disableRipple
          disableElevation
          href={COMMONS_FRONTEND_URL}
          sx={{
            textTransform: "none",
            px: 4,
            py: 1.5,
            fontSize: "1rem",
            borderRadius: 2,
          }}
        >
          Go to Materiom Commons
        </Button>
      </Container>
    </Box>
  );
};

export default AccessDenied;
